(() => {
  'use strict';
  const tag = 'cilea-custom-studio';
  if (customElements.get(tag)) return;
  const regions = [{"type":"svg_path","viewBox":"0 0 700 700","main_stone_path":"M 328 278 C 347 255 380 259 400 268 C 423 280 435 303 430 337 C 429 374 411 399 382 418 C 348 398 321 362 310 332 C 303 317 303 306 305 297 L 325 294 Z","main_stone_bounds_pixels":[302,262,431,421],"main_stone_bounds_normalized":[0.43142857142857144,0.3742857142857143,0.6157142857142858,0.6014285714285714],"note":"Teardrop points down and slightly right. Path deliberately avoids most upper-left gold prong. Keep bottom gold prong visible; path is conservative approximation."},{"type":"circles","coordinate_system":"normalized_0_to_1","circles":[{"cx":0.434375,"cy":0.50625,"r":0.0145},{"cx":0.4525,"cy":0.53625,"r":0.0145},{"cx":0.46875,"cy":0.565625,"r":0.0145},{"cx":0.48875,"cy":0.595,"r":0.0145},{"cx":0.505,"cy":0.62375,"r":0.0145},{"cx":0.52375,"cy":0.595625,"r":0.0145},{"cx":0.54125,"cy":0.56375,"r":0.0145},{"cx":0.55875,"cy":0.535,"r":0.0145},{"cx":0.57625,"cy":0.505,"r":0.0145}],"note":"Order from upper-left down to V tip and up right. Use per-stone masks, never a single V-shaped color patch over metal."},{"type":"circles","coordinate_system":"normalized_0_to_1","circles":[{"cx":0.5025,"cy":0.47375,"r":0.0155},{"cx":0.5525,"cy":0.489375,"r":0.0155},{"cx":0.593125,"cy":0.538125,"r":0.0155},{"cx":0.5925,"cy":0.60375,"r":0.0155},{"cx":0.55375,"cy":0.65125,"r":0.0155},{"cx":0.503125,"cy":0.6675,"r":0.0155},{"cx":0.451875,"cy":0.654375,"r":0.0155},{"cx":0.410625,"cy":0.606875,"r":0.0155},{"cx":0.410625,"cy":0.53875,"r":0.0155},{"cx":0.450625,"cy":0.49,"r":0.0155}],"note":"Clockwise order starting top center. Keep alternating gold beads uncolored."}];
  const renderer = (() => {
  const metals = new Set(['gold', 'white-gold', 'pink-gold']);
  const clamp = value => Math.max(0, Math.min(1, value));
  function hsl(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = n => { const k = (n + h / 30) % 12; return 255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))); };
    return [f(0), f(8), f(4)];
  }
  function expandMask(data, width, height, radius) {
    const horizontal = new Uint8Array(width * height), coverage = new Uint8Array(width * height);
    for (let y = 0; y < height; y++) {
      let count = 0;
      for (let x = -radius; x < width; x++) {
        const right = x + radius, left = x - radius - 1;
        if (right < width && data[(y * width + right) * 4] > 127) count++;
        if (left >= 0 && data[(y * width + left) * 4] > 127) count--;
        if (x >= 0) horizontal[y * width + x] = count > 0 ? 255 : 0;
      }
    }
    for (let x = 0; x < width; x++) {
      let count = 0;
      for (let y = -radius; y < height; y++) {
        const bottom = y + radius, top = y - radius - 1;
        if (bottom < height && horizontal[bottom * width + x]) count++;
        if (top >= 0 && horizontal[top * width + x]) count--;
        if (y >= 0) coverage[y * width + x] = count > 0 ? 255 : 0;
      }
    }
    return coverage;
  }
  function recolor({ pixels, stoneAlpha, metalCoverage, stone, metalColor, design, width, height }) {
    if (!metals.has(metalColor)) throw Error('Unknown metal color');
    if (pixels.length !== width * height * 4 || stoneAlpha.length !== pixels.length || metalCoverage.length !== width * height) throw Error('Invalid preview masks');
    const output = new Uint8ClampedArray(pixels);
    for (let i = 0, n = 0; i < pixels.length; i += 4, n++) {
      if (!pixels[i + 3]) continue;
      const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];
      const warm = r - b, stoneMix = stoneAlpha[i + 3] / 255;
      const stonePixel = stoneMix > 0 && !(design === 'ring' && r > b + 12 && g > b + 4);
      const x = n % width / width, y = Math.floor(n / width) / height;
      const sideStone = design === 'ring' && Math.hypot(x - .447, y - .554) < .021;
      if (metalColor !== 'gold' && metalCoverage[n] && !stonePixel && !sideStone) {
        const strength = clamp((warm - 6) / 10) * clamp((g - b - 3) / 7);
        if (strength) {
          const luminance = r * .2126 + g * .7152 + b * .0722;
          const target = metalColor === 'white-gold'
            ? [luminance + warm * .02, luminance, luminance - warm * .01]
            : [luminance + warm * .29, luminance - warm * .075, luminance - warm * .10];
          for (let c = 0; c < 3; c++) output[i + c] = pixels[i + c] * (1 - strength) + target[c] * strength;
        }
      }
      if (stonePixel) {
        const lum = (r * .2126 + g * .7152 + b * .0722) / 255;
        const target = hsl(stone.h, stone.s, Math.min(.93, Math.max(.12, lum * .88)));
        const mix = stoneMix * .92;
        for (let c = 0; c < 3; c++) output[i + c] = pixels[i + c] * (1 - mix) + target[c] * mix;
      }
    }
    return output;
  }

    return {expandMask, recolor};
  })();
  function initialize(root, config, host) {
    const $ = id => root.getElementById(id);
    const make = name => host.ownerDocument.createElement(name);
    const t = (key, values = {}) => String(config.strings[key] ?? key).replace(/\[\[(\w+)\]\]/g, (_, name) => String(values[name] ?? ''));
    const products = {
      ring: {name:t('design_ring'),title:'Lumière',category:'ring',image:config.assets.ring,region:0,crop:[0,0,1,1]},
      vline: {name:t('design_vline'),title:'V line',category:'necklace',image:config.assets.vline,region:1,crop:[.15,.12,.7,.7]},
      round: {name:t('design_round'),title:'Round line',category:'necklace',image:config.assets.round,region:2,crop:[.15,.15,.7,.7]}
    };
    const stones = [
      {key:'garnet',color:'#9d3149',h:345,s:.68},{key:'amethyst',color:'#8f65b6',h:274,s:.48},
      {key:'aquamarine',color:'#8dc8d5',h:192,s:.45},{key:'morganite',color:'#e9b4b3',h:4,s:.35},
      {key:'emerald',color:'#277c61',h:156,s:.65},{key:'moonstone',color:'#d2dce3',h:210,s:.12},
      {key:'ruby',color:'#c54269',h:342,s:.68},{key:'peridot',color:'#9cb654',h:78,s:.6},
      {key:'sapphire',color:'#405e99',h:221,s:.64},{key:'tourmaline',color:'#d685a9',h:332,s:.51},
      {key:'blue_topaz',color:'#87c5db',h:195,s:.48},{key:'tanzanite',color:'#6f73b0',h:237,s:.46}
    ].map(stone => ({...stone,name:t('stone_'+stone.key)}));
    const metals = {gold:{name:t('metal_gold'),color:'#d3b675'},'white-gold':{name:t('metal_white_gold'),color:'#d6d7d9'},'pink-gold':{name:t('metal_pink_gold'),color:'#dca69a'}};
    const references = {
      ring:{amount:37800,label:t('reference_ring'),url:'https://cilea.jp/products/lumiere-ring'},
      vline:{amount:69800,label:t('reference_necklace'),url:'https://cilea.jp/products/v-line-necklace'},
      round:{amount:69800,label:t('reference_necklace'),url:'https://cilea.jp/products/round-line-necklace'}
    };
    const state = {step:0,category:'ring',design:'ring',stone:10,metalColor:'gold',original:false};
    const rememberedDesigns = {ring:'ring',necklace:'vline'};
    const stepKeys = ['step_category','step_design','step_metal','step_stone'];
    const images = new Map();
    const controller = new AbortController();
    const on = (node, event, handler) => node.addEventListener(event, handler, {signal:controller.signal});
    const ctx = $('preview').getContext('2d',{willReadFrequently:true});
    let token = 0, interactionVersion = 0, disposed = false, summaryOpening = false, navigationQueued = null, swipe = null;
    const metalLabel = () => metals[state.metalColor].name;
    const referenceLabel = () => new Intl.NumberFormat(config.locale || 'ja-JP',{style:'currency',currency:'JPY',maximumFractionDigits:0}).format(references[state.design].amount)+t('tax_included');
    async function imageFor(url) {
      if (!images.has(url)) {
        const pending = (async () => {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.src = url;
          await image.decode();
          return image;
        })();
        images.set(url,pending);
        pending.catch(() => images.delete(url));
      }
      return images.get(url);
    }
    async function draw() {
      const own = ++token, selected = {...state}, product = products[selected.design], stone = stones[selected.stone];
      $('preview').setAttribute('aria-busy','true');
      try {
        const [image,metalMask] = await Promise.all([imageFor(product.image),selected.original ? null : imageFor(config.assets[selected.design+'_mask'])]);
        if (disposed || own !== token) return false;
        const width = image.naturalWidth, height = image.naturalHeight;
        const layer = make('canvas'); layer.width = width; layer.height = height;
        const layerContext = layer.getContext('2d',{willReadFrequently:true});
        layerContext.drawImage(image,0,0);
        if (!selected.original) {
          const region = regions[product.region], mask = make('canvas'); mask.width = width; mask.height = height;
          const maskContext = mask.getContext('2d',{willReadFrequently:true}); maskContext.fillStyle = '#fff';
          if (region.type === 'svg_path') maskContext.fill(new Path2D(region.main_stone_path));
          else region.circles.forEach(circle => {maskContext.beginPath();maskContext.arc(circle.cx*width,circle.cy*height,circle.r*width,0,Math.PI*2);maskContext.fill();});
          const stoneAlpha = maskContext.getImageData(0,0,width,height).data;
          maskContext.clearRect(0,0,width,height); maskContext.drawImage(metalMask,0,0,width,height);
          const metalCoverage = renderer.expandMask(maskContext.getImageData(0,0,width,height).data,width,height,Math.ceil(width*(selected.design==='ring'?.008:.026)));
          const pixels = layerContext.getImageData(0,0,width,height);
          pixels.data.set(renderer.recolor({pixels:pixels.data,stoneAlpha,metalCoverage,stone,metalColor:selected.metalColor,design:selected.design,width,height}));
          layerContext.putImageData(pixels,0,0);
        }
        if (disposed || own !== token) return false;
        const [x,y,cropWidth,cropHeight] = product.crop;
        ctx.clearRect(0,0,1000,1000);ctx.drawImage(layer,x*width,y*height,cropWidth*width,cropHeight*height,0,0,1000,1000);
        const metal = metals[selected.metalColor].name;
        $('preview').setAttribute('aria-label',t(selected.original?'preview_original_alt':'preview_rendered_alt',{design:product.name,stone:stone.name,metal}));
        $('previewSubtitle').textContent = selected.original ? product.name+' / '+t('original_photo') : product.name+' × '+stone.name;
        $('previewNotice').textContent = t(selected.original?'original_notice':'preview_notice_short');
        $('previewMetal').textContent = t('metal_prefix')+metal+t(selected.original?'original_unapplied':'simulated_finish');
        $('original').textContent = t(selected.original?'back_to_color':'view_original');
        $('preview').setAttribute('aria-busy','false');
        return true;
      } catch (error) {
        if (disposed || own !== token) return false;
        ctx.clearRect(0,0,1000,1000);
        $('preview').setAttribute('aria-busy','false');
        $('preview').setAttribute('aria-label',t('image_error'));
        $('previewSubtitle').textContent = t('image_error');
        $('previewNotice').textContent = t('image_error');
        $('previewMetal').textContent = t('metal_prefix')+metals[selected.metalColor].name+t('image_unavailable');
        $('original').textContent = t(selected.original?'back_to_color':'view_original');
        return false;
      }
    }
    function optionButton(className,key,value,selected,label) {
      const button = make('button');button.type='button';button.className=className+(selected?' selected':'');
      button.dataset[key] = value;button.setAttribute('aria-pressed',String(selected));
      if(label)button.setAttribute('aria-label',label);
      return button;
    }
    function addText(parent,tagName,text) {const node=make(tagName);node.textContent=text;parent.append(node);return node;}
    function invalidateInteraction() {interactionVersion++;summaryOpening=false;$('next').disabled=false;}
    function render(drawPreview = true) {
      const stoneScroll = $('stones').scrollLeft;
      const active = root.activeElement;
      const focusKey = active?.dataset.metalColor ? ['metalColor',active.dataset.metalColor] : active?.dataset.stone!==undefined ? ['stone',active.dataset.stone] : active?.dataset.design ? ['design',active.dataset.design] : null;
      root.querySelectorAll('[data-step]').forEach(item=>{const selected=Number(item.dataset.step)===state.step;item.setAttribute('aria-current',selected?'step':'false');});
      for(let i=0;i<4;i++)$('panel'+i).hidden=i!==state.step;
      $('stepTitle').textContent=t(stepKeys[state.step]);
      $('stepCount').textContent=String(state.step+1).padStart(2,'0')+' / 04';
      root.querySelectorAll('[data-category]').forEach(button=>{const selected=button.dataset.category===state.category;button.classList.toggle('selected',selected);button.setAttribute('aria-pressed',String(selected));});
      $('designs').replaceChildren();
      for(const [id,product] of Object.entries(products).filter(([,product])=>product.category===state.category)) {
        const button=optionButton('design-card','design',id,id===state.design);
        const image=make('img');image.src=product.image;image.alt=t('product_photo_alt',{design:product.name});image.width=700;image.height=700;image.loading='lazy';
        button.append(image);addText(button,'span',product.name);addText(button,'small',product.title);$('designs').append(button);
      }
      $('stones').replaceChildren();
      stones.forEach((stone,index)=>{
        const button=optionButton('stone','stone',String(index),index===state.stone,t('stone_option_alt',{month:index+1,stone:stone.name}));
        addText(button,'small',t('month_label',{month:String(index+1).padStart(2,'0')}));
        const swatch=make('span');swatch.className='swatch';swatch.style.setProperty('--stone',stone.color);swatch.setAttribute('aria-hidden','true');button.append(swatch);
        addText(button,'span',stone.name);$('stones').append(button);
      });
      $('metals').replaceChildren();
      for(const [id,metal] of Object.entries(metals)) {
        const button=optionButton('metal','metalColor',id,id===state.metalColor,t('metal_option_alt',{metal:metal.name}));
        const swatch=make('span');swatch.className='metal-swatch';swatch.style.setProperty('--metal',metal.color);swatch.setAttribute('aria-hidden','true');button.append(swatch);
        addText(button,'span',metal.name);$('metals').append(button);
      }
      const product=products[state.design], stone=stones[state.stone], reference=references[state.design];
      $('designTitle').textContent=product.title;
      if(drawPreview){$('previewSubtitle').textContent=product.name+' × '+stone.name;
      $('previewMetal').textContent=t('metal_prefix')+metalLabel()+t('rendering');}
      $('categoryLabel').textContent=t(state.category==='ring'?'ring_collection':'necklace_collection');
      $('stoneName').textContent=stone.name;
      $('stoneMonth').textContent=t('birthstone_option',{month:state.stone+1});
      $('selection').textContent=product.name+' / '+metalLabel()+' / '+stone.name;
      $('back').disabled=state.step===0;
      $('back').setAttribute('aria-label',t('previous_step'));
      $('back').setAttribute('aria-controls','panel'+Math.max(0,state.step-1));
      $('referencePrice').textContent=t('reference_prefix')+referenceLabel();
      $('referenceDetail').textContent=reference.label+' ／ '+t('reference_date');
      $('referenceLink').href=reference.url;
      $('summaryReference').textContent=referenceLabel()+'（'+reference.label+'）';
      $('pricingStatus').textContent=t('quote_status');
      $('next').textContent=state.step===3?t('review_short'):'→';
      $('next').classList.toggle('is-review',state.step===3);
      $('next').setAttribute('aria-label',t(['choose_design','next_metal','next_stone','review_selections'][state.step]));
      $('next').setAttribute('aria-controls',state.step===3?'summary':'panel'+(state.step+1));
      $('stones').scrollLeft=stoneScroll;
      if(focusKey) [...root.querySelectorAll('button')].find(button=>button.dataset[focusKey[0]]===focusKey[1])?.focus({preventScroll:true});
      if(drawPreview)void draw();
    }
    function moveStep(next) {
      if(disposed || $('summary').open || $('lightbox').open || !Number.isInteger(next) || next<0 || next>3 || next===state.step)return;
      invalidateInteraction();state.step=next;render(false);
      if(state.step===3) {
        const selected=[...root.querySelectorAll('[data-stone]')].find(button=>Number(button.dataset.stone)===state.stone);
        const rail=$('stones'), item=selected?.getBoundingClientRect(), box=rail.getBoundingClientRect();
        if(item && box.width>0)rail.scrollLeft+=item.left-box.left-(box.width-item.width)/2;
      }
    }
    function navigate(delta,event) {
      if(event?.detail>1 || navigationQueued===delta || disposed)return;
      navigationQueued=delta;queueMicrotask(()=>{navigationQueued=null;});
      if(delta>0 && state.step===3)void showSummary();else moveStep(state.step+delta);
    }
    function exportedImage() {
      const canvas=make('canvas');canvas.width=1000;canvas.height=1240;
      const context=canvas.getContext('2d');context.fillStyle='#faf9f6';context.fillRect(0,0,1000,1240);context.drawImage($('preview'),0,0);
      const line=(text,y,size,family='sans-serif')=>{context.font=size+'px '+family;while(context.measureText(text).width>900&&size>12){size--;context.font=size+'px '+family;}context.fillText(text,50,y,900);};
      context.fillStyle='#272727';line('Cilea  /  Your own piece',1045,36,'Georgia');
      line(products[state.design].name+' × '+(state.original?t('original_photo'):stones[state.stone].name),1090,23);
      line(t('metal_prefix')+metalLabel()+t(state.original?'original_unapplied':'simulated_finish'),1130,23);
      context.fillStyle='#666';line(t(state.original?'original_notice':'export_notice'),1170,18);line(t('export_manufacturing_notice'),1210,18);
      return canvas.toDataURL('image/png');
    }
    async function showSummary() {
      if(summaryOpening || disposed || state.step!==3)return;summaryOpening=true;$('next').disabled=true;
      const version=interactionVersion;
      try {
        state.original=false;if(!await draw() || disposed || version!==interactionVersion || state.step!==3)return;
        $('summaryImage').src=exportedImage();
        $('summaryCategory').textContent=t(state.category==='ring'?'category_ring':'category_necklace');
        $('summaryDesign').textContent=products[state.design].name;
        $('summaryMetal').textContent=metalLabel()+t('metal_unconfirmed');
        $('summaryStone').textContent=stones[state.stone].name+t('month_candidate',{month:state.stone+1});
        $('summaryPrice').textContent=t('quote_required');$('summaryLead').textContent=t('lead_unconfirmed');
        $('quoteText').value=[t('consultation_title'),t('category_prefix')+$('summaryCategory').textContent,t('design_prefix')+products[state.design].name,t('metal_prefix')+metalLabel()+t('metal_purity_unconfirmed'),t('stone_prefix')+stones[state.stone].name,t('reference_prefix')+referenceLabel()+'（'+references[state.design].label+'）',t('custom_price_prefix')+t('quote_required'),t('lead_prefix')+t('lead_unconfirmed'),t('consultation_question'),t('consultation_notice')].join('\n');
        const line=$('consultationLine'), profile=$('consultationProfile');
        if(globalThis.CileaConsultation && line && profile) {
          const consultation=globalThis.CileaConsultation.createBirthstoneDraft({design:state.design,stone:state.stone,metalColor:state.metalColor});
          $('quoteText').value=consultation.text;
          line.href=consultation.prefillUrl;line.hidden=false;
          profile.href=consultation.profileUrl;profile.hidden=false;
        }
        $('quoteFeedback').textContent=t('copy_unsent');
        if(!$('summary').open)$('summary').showModal();
      } finally {if(version===interactionVersion){summaryOpening=false;if(!disposed)$('next').disabled=false;}}
    }
    on(root,'click',event=>{
      const button=event.target.closest('button');if(!button||button.disabled)return;
      if(Object.hasOwn(rememberedDesigns,button.dataset.category)){
        const category=button.dataset.category;
        if(category===state.category)return;
        rememberedDesigns[state.category]=state.design;state.category=category;state.design=rememberedDesigns[category];
        invalidateInteraction();state.original=false;render();
      }
      if(button.dataset.design&&Object.hasOwn(products,button.dataset.design)){invalidateInteraction();state.design=button.dataset.design;state.category=products[state.design].category;rememberedDesigns[state.category]=state.design;state.original=false;render();}
      if(button.dataset.metalColor&&Object.hasOwn(metals,button.dataset.metalColor)){invalidateInteraction();state.metalColor=button.dataset.metalColor;state.original=false;render();}
      if(button.dataset.stone!==undefined){const index=Number(button.dataset.stone);if(Number.isInteger(index)&&index>=0&&index<12){invalidateInteraction();state.stone=index;state.original=false;render();}}
    });
    on($('next'),'click',event=>navigate(1,event));
    on($('back'),'click',event=>navigate(-1,event));
    const swipeArea=$('stepSwipe');
    on(swipeArea,'pointerdown',event=>{
      if(event.isPrimary===false){swipe=null;return;}
      if(!['touch','pen'].includes(event.pointerType) || event.button!==0 || event.target!==swipeArea || host.ownerDocument.getSelection?.()?.toString())return;
      swipe={id:event.pointerId,x:event.clientX,y:event.clientY,axis:null,version:interactionVersion};
      swipeArea.setPointerCapture?.(event.pointerId);
    });
    on(swipeArea,'pointermove',event=>{
      if(!swipe || event.pointerId!==swipe.id)return;
      const x=Math.abs(event.clientX-swipe.x),y=Math.abs(event.clientY-swipe.y);
      if(!swipe.axis && Math.max(x,y)>12)swipe.axis=x>y*1.6?'horizontal':'vertical';
    });
    on(swipeArea,'pointerup',event=>{
      const gesture=swipe;swipe=null;
      if(!gesture || event.pointerId!==gesture.id || gesture.version!==interactionVersion)return;
      const x=event.clientX-gesture.x,y=event.clientY-gesture.y;
      if(gesture.axis!=='vertical' && Math.abs(x)>=48 && Math.abs(x)>Math.abs(y)*1.6)moveStep(state.step+(x<0?1:-1));
    });
    for(const event of ['pointercancel','lostpointercapture'])on(swipeArea,event,()=>{swipe=null;});
    on($('original'),'click',()=>{invalidateInteraction();state.original=!state.original;void draw();});
    for(const id of ['close','edit'])on($(id),'click',()=>$('summary').close());
    on($('summary'),'close',()=>{if(!disposed)$('next').focus({preventScroll:true});});
    on($('lightbox'),'close',()=>{if(!disposed)$('zoom').focus({preventScroll:true});});
    on($('download'),'click',()=>{if(!$('summaryImage').src.startsWith('data:image/png;'))return;const link=make('a');link.download='cilea-design-preview.png';link.href=$('summaryImage').src;root.append(link);link.click();link.remove();});
    on($('zoom'),'click',async()=>{const version=interactionVersion;if(!await draw() || disposed || version!==interactionVersion)return;$('largeImage').src=exportedImage();if(!$('lightbox').open)$('lightbox').showModal();});
    on($('closeZoom'),'click',()=>$('lightbox').close());
    for(const id of ['summary','lightbox'])on($(id),'click',event=>{if(event.target!==$(id))return;const rect=$(id).getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)$(id).close();});
    on($('copyQuote'),'click',async()=>{try{await navigator.clipboard.writeText($('quoteText').value);if(!disposed)$('quoteFeedback').textContent=t('copied_unsent');}catch{if(disposed)return;$('quoteText').focus();$('quoteText').select();$('quoteFeedback').textContent=t('copy_fallback');}});
    render();
    return ()=>{disposed=true;token++;interactionVersion++;swipe=null;controller.abort();for(const id of ['summary','lightbox'])if($(id).open)$(id).close();images.clear();};
  }
  customElements.define(tag,class extends HTMLElement {
    connectedCallback() {
      if(this._mounted)return;
      const mount=()=>{
        if(!this.isConnected||this._mounted)return false;
        const template=this.querySelector('template[data-cilea-template]'),settings=this.querySelector('script[data-cilea-config]');
        if(!template||!settings)return false;
        let config;
        try {
          config=JSON.parse(settings.textContent);
          if(!config.assets||!config.strings)throw Error('Invalid configuration');
          for(const key of ['ring','vline','round','ring_mask','vline_mask','round_mask']) {
            const url=new URL(config.assets[key],this.ownerDocument.baseURI);
            if(!['http:','https:'].includes(url.protocol))throw Error('Invalid asset URL');
          }
        } catch {return false;}
        this._mounted=true;
        const root=this.shadowRoot||this.attachShadow({mode:'open'});root.replaceChildren(template.content.cloneNode(true));
        root.querySelectorAll('button').forEach(button=>button.type='button');
        this._cleanup=initialize(root,config,this);
        this._observer?.disconnect();return true;
      };
      if(!mount()){this._observer=new MutationObserver(mount);this._observer.observe(this,{childList:true,subtree:true});}
    }
    disconnectedCallback() {
      this._observer?.disconnect();this._cleanup?.();this._cleanup=null;this._mounted=false;this.shadowRoot?.replaceChildren();
    }
  });
})();
